import { render, staticRenderFns } from "./yuxingSuccess.vue?vue&type=template&id=4c0499bc&lang=pug&"
import script from "./yuxingSuccess.vue?vue&type=script&lang=js&"
export * from "./yuxingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./yuxingSuccess.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports